export const ADMIN_APPTS_LIST_REQUEST = "ADMIN_APPTS_LIST_REQUEST";
export const ADMIN_APPTS_LIST_SUCCESS = "ADMIN_APPTS_LIST_SUCCESS";
export const ADMIN_APPTS_LIST_FAIL = "ADMIN_APPTS_LIST_FAIL";

export const ADMIN_APPT_ASSIGN_REQUEST = "ADMIN_APPT_ASSIGN_REQUEST";
export const ADMIN_APPT_ASSIGN_SUCCESS = "ADMIN_APPT_ASSIGN_SUCCESS";
export const ADMIN_APPT_ASSIGN_FAIL = "ADMIN_APPT_ASSIGN_FAIL";

export const ADMIN_APPT_REJECT_REQUEST = "ADMIN_APPT_REJECT_REQUEST";
export const ADMIN_APPT_REJECT_SUCCESS = "ADMIN_APPT_REJECT_SUCCESS";
export const ADMIN_APPT_REJECT_FAIL = "ADMIN_APPT_REJECT_FAIL";

export const ADMIN_APPT_COMPLETE_REQUEST = "ADMIN_APPT_COMPLETE_REQUEST";
export const ADMIN_APPT_COMPLETE_SUCCESS = "ADMIN_APPT_COMPLETE_SUCCESS";
export const ADMIN_APPT_COMPLETE_FAIL = "ADMIN_APPT_COMPLETE_FAIL";

export const ADMIN_APPT_REPORT_REQUEST = "ADMIN_APPT_REPORT_REQUEST";
export const ADMIN_APPT_REPORT_SUCCESS = "ADMIN_APPT_REPORT_SUCCESS";
export const ADMIN_APPT_REPORT_FAIL = "ADMIN_APPT_REPORT_FAIL";

export const ADMIN_PAYMENT_REQUEST = "ADMIN_PAYMENT_REQUEST";
export const ADMIN_PAYMENT_SUCCESS = "ADMIN_PAYMENT_SUCCESS";
export const ADMIN_PAYMENT_FAIL = "ADMIN_PAYMENT_FAIL";
